module.exports = __webpack_public_path__ + "static/index/img/baikal-1005.13deda23.jpg";